import $ from "jquery";
import { fetchInventory } from '../utilities.js';


const $links = $('.js-inventory-link');



if ($links.length != 0) {
    fetchInventory().then(function (vehicles) {

        const MODELS = [];

        for (const item of vehicles) {
            MODELS.push(item.model.name);
        }

        $links.each(function() {
            const $section = $(this);
            const model = $section.data('model');
            const $loader = $section.find('.js-inventory-link-loader');

            if (MODELS.includes(model)) {
                const count = MODELS.filter( modelName => modelName.toLowerCase() == model.toLowerCase()).length;
                const URL = $section.data('href');
                const $link = $section.find('.js-inventory-link-url');
                $link.attr('href', `${URL}?dsp_model=${encodeURIComponent(model.toLowerCase().replaceAll(' ', '-'))}`);
                $section.find('.js-inventory-link-count').text(count);
                $link.removeClass('inactive');
            } else {
                $section.find('.js-inventory-link-fallback').removeClass('inactive');
            }
            $loader.remove();

        })



    });

}






